var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServerKomplet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 120.37 78.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.19,
    y: 52.46,
    width: 119.82,
    height: 23.45,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.19,
    y: 52.46,
    width: 119.82,
    height: 23.45,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".38px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.19,
    y: 52.46,
    width: 119.82,
    height: 23.45,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.19,
    y: 26.32,
    width: 119.82,
    height: 23.45,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.19,
    y: 26.32,
    width: 119.82,
    height: 23.45,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".38px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.19,
    y: 26.32,
    width: 119.82,
    height: 23.45,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.19,
    width: 119.82,
    height: 23.45,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.19,
    width: 119.82,
    height: 23.45,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".38px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.19,
    width: 119.82,
    height: 23.45,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.19,
    y: 74.6,
    width: 119.82,
    height: 3.99,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#d)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.19,
    y: 52.46,
    width: 8.25,
    height: 23.45,
    style: {
      fill: "#d1c4dd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.42,
    y: 59.18,
    width: 97.17,
    height: 14.91,
    rx: 1.31,
    ry: 1.31,
    style: {
      fill: "#d1c4dd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.84,
    y: 54.46,
    width: 5.44,
    height: 19.64,
    rx: 1.31,
    ry: 1.31,
    style: {
      fill: "#d1c4dd"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.19,
    y: 52.46,
    width: 119.82,
    height: 23.45,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "#615b67"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#e)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.19,
    y: 52.46,
    width: 8.25,
    height: 23.45,
    style: {
      fill: "#f47c4a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.42,
    y: 59.18,
    width: 97.17,
    height: 14.91,
    rx: 1.31,
    ry: 1.31,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".46px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.84,
    y: 54.46,
    width: 5.44,
    height: 19.64,
    rx: 1.31,
    ry: 1.31,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".46px"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.19,
    y: 52.46,
    width: 119.82,
    height: 23.45,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".38px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#f)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.19,
    y: 52.46,
    width: 8.25,
    height: 23.45,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.42,
    y: 59.18,
    width: 97.17,
    height: 14.91,
    rx: 1.31,
    ry: 1.31,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.84,
    y: 54.46,
    width: 5.44,
    height: 19.64,
    rx: 1.31,
    ry: 1.31,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2.64,
    y: 54.46,
    width: 3.41,
    height: 3.41,
    rx: 1.7,
    ry: 1.7,
    style: {
      fill: "#67c189",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.92,
    y: 54.46,
    width: 3.41,
    height: 3.41,
    rx: 1.7,
    ry: 1.7,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.87,
    y: 54.46,
    width: 3.41,
    height: 3.41,
    rx: 1.7,
    ry: 1.7,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.81,
    y: 54.46,
    width: 3.41,
    height: 3.41,
    rx: 1.7,
    ry: 1.7,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.76,
    y: 54.46,
    width: 3.41,
    height: 3.41,
    rx: 1.7,
    ry: 1.7,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.36,
    y: 68.35,
    width: 1.97,
    height: 1.97,
    rx: 0.98,
    ry: 0.98,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.36,
    y: 71.57,
    width: 1.97,
    height: 1.97,
    rx: 0.98,
    ry: 0.98,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.47,
    y: 55.18,
    width: 7.68,
    height: 1.97,
    style: {
      fill: "#fff",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.96,
    y: 55.18,
    width: 7.68,
    height: 1.97,
    style: {
      fill: "#67c189",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.25,
    y: 55.18,
    width: 7.68,
    height: 1.97,
    style: {
      fill: "#fff",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.16,
    y: 55.18,
    width: 3.01,
    height: 1.97,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.93,
    y: 55.18,
    width: 3.01,
    height: 1.97,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.94,
    y: 55.18,
    width: 3.01,
    height: 1.97,
    style: {
      fill: "#77acdd",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.19,
    y: 48.46,
    width: 119.82,
    height: 3.99,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#g)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.19,
    y: 26.32,
    width: 8.25,
    height: 23.45,
    style: {
      fill: "#d1c4dd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.42,
    y: 33.05,
    width: 97.17,
    height: 14.91,
    rx: 1.31,
    ry: 1.31,
    style: {
      fill: "#d1c4dd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.84,
    y: 28.32,
    width: 5.44,
    height: 19.64,
    rx: 1.31,
    ry: 1.31,
    style: {
      fill: "#d1c4dd"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.19,
    y: 26.32,
    width: 119.82,
    height: 23.45,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "#615b67"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#h)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.19,
    y: 26.32,
    width: 8.25,
    height: 23.45,
    style: {
      fill: "#f47c4a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.42,
    y: 33.05,
    width: 97.17,
    height: 14.91,
    rx: 1.31,
    ry: 1.31,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".46px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.84,
    y: 28.32,
    width: 5.44,
    height: 19.64,
    rx: 1.31,
    ry: 1.31,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".46px"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.19,
    y: 26.32,
    width: 119.82,
    height: 23.45,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".38px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#i)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.19,
    y: 26.32,
    width: 8.25,
    height: 23.45,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.42,
    y: 33.05,
    width: 97.17,
    height: 14.91,
    rx: 1.31,
    ry: 1.31,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.84,
    y: 28.32,
    width: 5.44,
    height: 19.64,
    rx: 1.31,
    ry: 1.31,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2.64,
    y: 28.32,
    width: 3.41,
    height: 3.41,
    rx: 1.7,
    ry: 1.7,
    style: {
      fill: "#67c189",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.92,
    y: 28.32,
    width: 3.41,
    height: 3.41,
    rx: 1.7,
    ry: 1.7,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.87,
    y: 28.32,
    width: 3.41,
    height: 3.41,
    rx: 1.7,
    ry: 1.7,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.81,
    y: 28.32,
    width: 3.41,
    height: 3.41,
    rx: 1.7,
    ry: 1.7,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.76,
    y: 28.32,
    width: 3.41,
    height: 3.41,
    rx: 1.7,
    ry: 1.7,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.36,
    y: 42.21,
    width: 1.97,
    height: 1.97,
    rx: 0.98,
    ry: 0.98,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.36,
    y: 45.43,
    width: 1.97,
    height: 1.97,
    rx: 0.98,
    ry: 0.98,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.47,
    y: 29.04,
    width: 7.68,
    height: 1.97,
    style: {
      fill: "#fff",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.96,
    y: 29.04,
    width: 7.68,
    height: 1.97,
    style: {
      fill: "#67c189",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.25,
    y: 29.04,
    width: 7.68,
    height: 1.97,
    style: {
      fill: "#fff",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.16,
    y: 29.04,
    width: 3.01,
    height: 1.97,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.93,
    y: 29.04,
    width: 3.01,
    height: 1.97,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.94,
    y: 29.04,
    width: 3.01,
    height: 1.97,
    style: {
      fill: "#77acdd",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 22.33,
    width: 119.82,
    height: 3.99,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#j)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.19,
    width: 8.25,
    height: 23.45,
    style: {
      fill: "#d1c4dd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.59,
    y: 6.91,
    width: 97.17,
    height: 14.91,
    rx: 1.31,
    ry: 1.31,
    style: {
      fill: "#d1c4dd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 2.19,
    width: 5.44,
    height: 19.64,
    rx: 1.31,
    ry: 1.31,
    style: {
      fill: "#d1c4dd"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.19,
    width: 119.82,
    height: 23.45,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "#615b67"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#k)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.19,
    width: 8.25,
    height: 23.45,
    style: {
      fill: "#f47c4a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.59,
    y: 6.91,
    width: 97.17,
    height: 14.91,
    rx: 1.31,
    ry: 1.31,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".46px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 2.19,
    width: 5.44,
    height: 19.64,
    rx: 1.31,
    ry: 1.31,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".46px"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.19,
    width: 119.82,
    height: 23.45,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".38px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#l)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.19,
    width: 8.25,
    height: 23.45,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.59,
    y: 6.91,
    width: 97.17,
    height: 14.91,
    rx: 1.31,
    ry: 1.31,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 2.19,
    width: 5.44,
    height: 19.64,
    rx: 1.31,
    ry: 1.31,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2.81,
    y: 2.19,
    width: 3.41,
    height: 3.41,
    rx: 1.7,
    ry: 1.7,
    style: {
      fill: "#67c189",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.09,
    y: 2.19,
    width: 3.41,
    height: 3.41,
    rx: 1.7,
    ry: 1.7,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.03,
    y: 2.19,
    width: 3.41,
    height: 3.41,
    rx: 1.7,
    ry: 1.7,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.98,
    y: 2.19,
    width: 3.41,
    height: 3.41,
    rx: 1.7,
    ry: 1.7,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.93,
    y: 2.19,
    width: 3.41,
    height: 3.41,
    rx: 1.7,
    ry: 1.7,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.53,
    y: 16.08,
    width: 1.97,
    height: 1.97,
    rx: 0.98,
    ry: 0.98,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.53,
    y: 19.3,
    width: 1.97,
    height: 1.97,
    rx: 0.98,
    ry: 0.98,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.63,
    y: 2.91,
    width: 7.68,
    height: 1.97,
    style: {
      fill: "#fff",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.12,
    y: 2.91,
    width: 7.68,
    height: 1.97,
    style: {
      fill: "#67c189",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.41,
    y: 2.91,
    width: 7.68,
    height: 1.97,
    style: {
      fill: "#fff",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.33,
    y: 2.91,
    width: 3.01,
    height: 1.97,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.09,
    y: 2.91,
    width: 3.01,
    height: 1.97,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.11,
    y: 2.91,
    width: 3.01,
    height: 1.97,
    style: {
      fill: "#77acdd",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerKomplet);
export default __webpack_public_path__ + "static/media/server_komplet.382f6c77fcf3b2f9286fefc470df125d.svg";
export { ForwardRef as ReactComponent };